import { useCallback, useContext } from 'react';

import { UiContext } from '../context/UiContext';

export default function useConfirmDelete(onDelete, type, { isPermanent = false } = {}) {
  const { showConfirmActionModal } = useContext(UiContext);

  const handleDelete = useCallback(
    (item) => {
      let message;
      if (isPermanent) {
        message = type === 'folder'
          ? `This folder and all of its content will be <b>permanently deleted</b>, and cannot be restored.<br/><span style="display:inline-block;margin-top:12px;">Are you sure you want to delete this folder?</span>`
          : `This ${type} will be <b>permanently deleted</b>, and cannot be restored.<br/><span style="display:inline-block;margin-top:12px;">Are you sure you want to delete this ${type}?</span>`;
      } else {
        message = `Are you sure you want to delete this ${type}?`;
      }
      showConfirmActionModal({
        message,
        onConfirm: () => onDelete(item.id),
      });
    },
    [onDelete, showConfirmActionModal, type, isPermanent]
  );

  return handleDelete;
}
